import { useTranslation } from "react-i18next";
import {
  useCreateChoiceBoard,
  useGetChoiceBoard,
  getChoiceBoard,
} from "@packages/api/madlenAPI";
import { ChoiceBoardResponseDto } from "@packages/api/madlenAPI.schemas";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import {
  Choice,
  ChoiceBoardCard,
} from "../../../components/choice-boards/ChoiceBoards";

const CreateChoiceBoardView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("choiceBoards.title")}
      backPath="/content/choice-boards"
      themeColor="green"
      loadingTitle={t("choiceBoards.result.loading.title")}
      errorTitle={t("choiceBoards.result.error.title")}
      errorDescription={t("choiceBoards.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={onSubmit!}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: ChoiceBoardResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => {
    const adaptedToolData = {
      ...toolData,
      activities: toolData.activities as Choice[],
    };

    return (
      <ChoiceBoardCard
        tool={adaptedToolData}
        isImageLoading={isImageLoading}
        onCreateAgain={onCreateAgain}
      />
    );
  };

  return (
    <GenericToolCreationPage
      toolType="choiceBoards"
      useCreateTool={useCreateChoiceBoard}
      useGetTool={useGetChoiceBoard}
      getTool={getChoiceBoard}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: ChoiceBoardResponseDto) => data?.activities}
    />
  );
};

export default CreateChoiceBoardView;
